<template>
  <div>
    <div class="menu-item-set">{{$t('m.cdlmsz')}}</div>
    <div class="xtable">
      <div class="twui-body-left">
        <el-tree
          key="dev-tree"
          ref="tree"
          class="tw-tree xsmall"
          node-key="id"
          highlight-current
          :data="devTreeData"
          :props="devTreeDefaultProps"
          :indent="8"
          :default-expanded-keys="devTreeExpandedKeys"
          :expand-on-click-node="false"
          @node-click="setMenuInfo"
        ></el-tree>
      </div>

      <div class="twui-body-space"></div>
      <div class="twui-body-right">
        <div class="xpadding-menuchange">
          <el-form v-if="!newflag" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item :label="$t('m.menuName')" prop="menuName">
              <el-input :disabled="!canSave" v-model="ruleForm.menuName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('m.superior')" prop="region">
              <el-select class="xselect-width" :disabled="!canSave" v-model="ruleForm.parentMenuId" :placeholder="$t('m.selectTop')">
                <el-option :label="$t('m.nothing')" value="0"></el-option>
                <el-option v-for="item in devTreeData" :key="item.menuId" :label="item.menuName" :value="item.menuId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item  :label="$t('m.sortNum')" prop="sortNum">
              <el-input :disabled="!canSave" v-model="ruleForm.sortNum"></el-input>
            </el-form-item>
            <el-form-item size="large" v-if="canSave">
              <el-button>{{$t('m.cancel')}}</el-button>
              <el-button type="primary" @click="updateDocMenu">{{$t('m.save')}}</el-button>
            </el-form-item>
          </el-form>

          <el-form v-else :model="newForm" :rules="rules" ref="newForm" label-width="100px" class="demo-ruleForm">
            <el-form-item :label="$t('m.menuName')" prop="menuName">
              <el-input v-model="newForm.menuName"></el-input>
            </el-form-item>
            <el-form-item :label="$t('m.superior')"   prop="region">
              <el-select class="xselect-width" v-model="newForm.region" :placeholder="$t('m.selectTop')" disabled>
                <el-option :label="$t('m.nothing')" value="0"></el-option>
                <el-option v-for="item in devTreeData" :key="item.menuId" :label="item.menuName" :value="item.menuId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('m.sortNum')" prop="sortNum">
              <el-input v-model="newForm.sortNum"></el-input>
            </el-form-item>
            <el-form-item v-if="newflag" :label="$t('m.appType')" prop="appType">
              <el-select v-model="newForm.appType">
                <el-option v-for="(item,index) in appTypes" :key="index" :label="item.label" :value="item.val"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item size="large">
              <el-button @click="newflag=false">{{$t('m.cancel')}}</el-button>
              <el-button type="primary" @click="addDocument">{{$t('m.add')}}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import webBase from '@/utils/webBase'
export default {
  data () {
    return {
      canSave: false,
      newForm: {},
      // 1-教学应用； 2-学习应用；3-管理应用；4-评价应用；5-教研应用；6-其他应用;8-课堂应用；9-授课工具
      appTypes: [
        {
          label: this.$i18n.messages[this.$i18n.locale].m.appTypeTeching,
          val: '1'
        },
        {
          label: this.$i18n.messages[this.$i18n.locale].m.appTypeStudy,
          val: '2'
        },
        {
          label: this.$i18n.messages[this.$i18n.locale].m.appTypeManage,
          val: '3'
        },
        {
          label: this.$i18n.messages[this.$i18n.locale].m.appTypeEvaluate,
          val: '4'
        },
        {
          label: this.$i18n.messages[this.$i18n.locale].m.appTypeResearch,
          val: '5'
        },
        {
          label: this.$i18n.messages[this.$i18n.locale].m.appTypeOthe,
          val: '6'
        },
        {
          label: this.$i18n.messages[this.$i18n.locale].m.appTypeClass,
          val: '8'
        },
        {
          label: this.$i18n.messages[this.$i18n.locale].m.appTypeOtherTools,
          val: '9'
        }
      ],
      newflag: false,
      devTreeDefaultProps: {
        children: 'children',
        label: 'menuName'
      },
      // 开发树节点: 默认展开的节点索引
      devTreeExpandedKeys: ['1'],

      // 弹出菜单节点上下文
      devTreeMenuContext: {
        data: null,
        node: null
      },
      devTreeData: [],
      ruleForm: {},
      rules: {
        menuName: [
          { required: true, message: '请输入菜单名称', trigger: 'blur' }
        ],
        sortNum: [{ required: true, message: '请输入序号', trigger: 'blur' }]
      },
      showTitle: webBase.showTitle()
    }
  },
  mounted: function () {
    this.getMenuList()
  },
  methods: {
    updateDocMenu () {
      this.axios
        .post('/openapi-uc/updateDocMenu', this.ruleForm)
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            this.$message.success('保存成功')
          }
        })
    },
    setMenuInfo (val) {
      if (val.parentMenuId === 'TWPAAS11000000004') {
        this.canSave = true
      } else {
        this.canSave = false
      }
      this.ruleForm = val
      this.newflag = false
    },
    renderTreePopBtn (h, { node, data, store }) {
      return (
        <span>
          <span>{node.label}</span>
          <span
            style={{
              float: 'right'
            }}
          >
            {data.menuId === 'TWPAAS11000000004' && (
              <i
                class="el-icon-plus"
                style={{
                  color: '#0b87f4',
                  marginRight: '10px'
                }}
                onClick={() => this.newDocMenu(data)}
              ></i>
            )}
            {data.parentMenuId === 'TWPAAS11000000004' &&
              data.menuClass === '2' && (
                <i
                  class="el-icon-delete"
                  style={{
                    color: '#0b87f4',
                    marginRight: '10px'
                  }}
                  onClick={() => this.deleteDocMenuById(data)}
                ></i>
              )}
          </span>
        </span>
      )
    },
    newDocMenu (v) {
      this.newflag = true
      this.newForm = {
        appType: '',
        createTime: '2019-01-09 10:13:21',
        creatorId: 'PAAS00110000000',
        initMenu: '1',
        lang: 'zh_CN',
        menuClass: '2',
        menuName: '',
        menuPath: '',
        parentMenuId: 'TWPAAS11000000004',
        sortNum: 0
      }
    },
    deleteDocMenuById (v) {
      this.$confirm(`确定要删除${v.menuName}?`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios
          .post('/openapi-uc/deleteDocMenuById', v.menuId)
          .then((res) => {
            if (res.data.serverResult.resultCode === '200') {
              this.$message({
                type: 'warning',
                message: `删除成功`
              })
              this.getMenuList()
            }
          })
      })
    },
    addDocument () {
      this.axios
        .post('/openapi-uc/docMenu/addDocMenu', this.newForm)
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            this.$message({
              type: 'success',
              message: `添加成功`
            })
            this.newflag = false
            this.getMenuList()
          }
        })
    },
    getMenuList (menuId) {
      this.axios
        .post('/openapi-uc/docMenu/queryDocMenuById/', {
          lang: window.localStorage.getItem('tw_i18n_local') === 'zh_CN' ? 'zh_CN' : 'en_US',
          menuId: menuId
        })
        .then((res) => {
          if (res.data.serverResult.resultCode === '200') {
            let menuList = res.data.pageInfo.list.filter((item) => {
              return item.menuClass === '1'
            })
            let menuList1 = res.data.pageInfo.list.filter((item) => {
              return item.menuClass === '2' || item.menuClass === '3'
            })
            menuList.map((item) => {
              this.$set(item, 'children', [])
              menuList1.map((item1) => {
                if (item.menuId === item1.parentMenuId) {
                  item.children.push(item1)
                }
              })
            })
            this.devTreeData = menuList
          } else {
            this.$message.error(res.data.serverResult.resultMessage)
          }
        })
    }
  }
}
</script>
<style scoped>
.xtable {
  margin-top: 30px;
}
.xpadding-menuchange {
  padding: 15% 25%;
}
.xselect-width {
  width: 100%;
}
.menu-item-set {
  font-size: 25px;
  margin: 25px 17%;
  border-bottom: 1px solid #e9eff4;
}
.tw-tree {
  background: #e4e8f1;
}
.menuIcon {
  float: right;
}
</style>


// WEBPACK FOOTER //
// document-menu.vue?dfd8bc96